const GET_PROFILE_USER_BY_NICKNAME = `
  query GetProfileUserByNicknameQuery($nickname: String!) {
    public {
      userByNickname(nickname: $nickname) {
        id
        isAdmin
        isVerified
        nickname
        image {
          id
          url(width: 64, height: 64)
        }
        createdAt
        totalComments
        totalOffers
        maxTemperature
        totalCommentLikes
        totalFollowedUsers
        totalUsersFollowing   
        totalCommentReactions {
          like
          funny
          helpful
        }
      }
    }
  }
`;

export default GET_PROFILE_USER_BY_NICKNAME;
